import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = {
  class: "D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_5 = { class: "F-Bold M-Auto" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "CookiesRowSplitter"
}
const _hoisted_8 = { class: "F-Bold F1_25em" }
const _hoisted_9 = {
  key: 2,
  class: "F-Bold F-CR F1_25em W-100"
}
const _hoisted_10 = {
  class: "F-Bold F1_25em BG4",
  style: {"padding":"1em","padding-bottom":"3em","margin-top":"3em","border-radius":"6px 6px 0 0"}
}
const _hoisted_11 = {
  class: "BG4",
  style: {"padding":"2em","border-radius":"0 0 6px 6px"}
}
const _hoisted_12 = {
  key: 0,
  class: "CookiesRowSplitter"
}
const _hoisted_13 = { class: "F-Bold F1_25em" }
const _hoisted_14 = { style: {"font-size":"0.75em","opacity":"0.6"} }
const _hoisted_15 = {
  key: 2,
  class: "F-Bold F-CR F1_25em W-100"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRow F-C2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    (_ctx.Saving || _ctx.Loading.length)
      ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
            class: "PrintButton Shadow2 BGRed D-Flex RowMargin NOPRINT",
            style: {"background-color":"var(--colorr1)"}
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Translate('Close')), 1)
          ])
        ]),
        (_ctx.ItemsLocations.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.Translate('No Data')), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CurrentLocations, (loc, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "DialogSection",
            id: "TableToPrint"
          }, [
            (index > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, _toDisplayString(loc.LocationDecoded), 1),
            (_ctx.SectionItems(loc.ID).length > 0)
              ? (_openBlock(), _createBlock(_component_CookiesTable, {
                  key: 1,
                  class: "Shadow1",
                  TableSettings: _ctx.TableSettings,
                  CookiesData: _ctx.SectionItems(loc.ID)
                }, null, 8, ["TableSettings", "CookiesData"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, "--" + _toDisplayString(_ctx.Translate('Empty')) + "--", 1))
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.Translate('Other Branches')), 1),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OtherLocations, (loc, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "DialogSection",
              id: "TableToPrint"
            }, [
              (index > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(loc.BranchName), 1),
                _createTextVNode(" >>> "),
                _createElementVNode("span", _hoisted_14, _toDisplayString(loc.LocationDecoded), 1)
              ]),
              (_ctx.SectionItems(loc.ID).length > 0)
                ? (_openBlock(), _createBlock(_component_CookiesTable, {
                    key: 1,
                    class: "Shadow1",
                    TableSettings: _ctx.TableSettings,
                    CookiesData: _ctx.SectionItems(loc.ID)
                  }, null, 8, ["TableSettings", "CookiesData"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, "--" + _toDisplayString(_ctx.Translate('Empty')) + "--", 1))
            ]))
          }), 128))
        ]),
        _hoisted_16,
        _hoisted_17
      ])
    ])
  ], 8, _hoisted_1))
}